// extracted by mini-css-extract-plugin
module.exports = {"versionHistory":"VersionHistory_versionHistory__10ADW","spinnerContainer":"VersionHistory_spinnerContainer__IEOeL"};